<template>
  <v-card>
    <v-card>
      <v-toolbar
          color="#286090"
          dark
          class="text-uppercase"
        >
          <img src="@/assets/logo_nuevo.png"style="width:50px;height:51px" class="mr-4">
          <h2>Firmar documento del Toca
            <b v-if="currentDocumento.apelacion">
              {{ currentDocumento.apelacion.toca.numero }}/{{ currentDocumento.apelacion.toca.anio }}
                ({{ currentDocumento.apelacion.tipo_juicio == 'JO' ? 'Juicio Oral' : 'Jucio Tradicional' }})
            </b>
          </h2>
        </v-toolbar>
      <v-card-text>
        <v-form @submit.prevent="AgregarFirmanteNes" ref="form" v-model="valid" lazy-validation>

          <template>
            <v-container>
              <v-card
                class="mx-auto"
              >
                <v-list shaped>
                  <v-subheader><h2 style="color: #B08836">Firmantes del {{formTitle}}</h2>
                    <v-spacer></v-spacer>
                    <v-btn v-if="currentDocumento.url_evidencia" x-small color="#607D8B" dark @click="getFile('evidencia')">
                      <v-icon x-small left>mdi-draw-pen</v-icon>
                      ver Evidencia
                    </v-btn>&nbsp;
                    <v-btn x-small color="#607D8B" dark @click="getFile('original')">
                      <v-icon small left>mdi-file-document</v-icon>
                      ver {{formTitle}}
                    </v-btn>
                  </v-subheader>
                  <v-list
                    multiple
                  >
                    <template v-for="(item, i) in firmasList">
                      <v-divider></v-divider>

                      <v-list-item>
                        <v-list-item-avatar color="#607D8B">
                          <v-icon dark>mdi-account-circle</v-icon>
                        </v-list-item-avatar>
                        <v-list-item-content>
                          <h3 v-if="item.magistrado.segundo_apellido">
                            {{item.magistrado.nombre+' '+item.magistrado.primer_apellido+' '+item.magistrado.segundo_apellido}}
                          </h3>
                          <h3 v-else>{{item.magistrado.nombre+' '+item.magistrado.primer_apellido}}
                          </h3>
                          <h3 v-if="item.firmado == 1">Firmado
                            <v-icon color="#08af19">
                              mdi-file-check
                            </v-icon><br>
                            Fecha de Firma: <span>{{item.fecha_firma | formatDateTime}}</span>
                          </h3>
                          <h3 v-else>Pendiente de Firma
                            <v-icon color="red">
                              mdi-file-remove
                            </v-icon>
                          </h3>
                        </v-list-item-content>
                      </v-list-item>
                    </template>
                  </v-list>
                </v-list>
              </v-card>
            </v-container>
          </template>

          <template v-for="(item, i) in firmasList">
            <v-card
              class="mx-auto"
              v-if="currentUser.id == item.magistrado_id && item.firmado == 0 && !currentDocumento.url_evidencia"
            >
              <v-container>
                <h2 style="color: #B08836" class="font-weight-bold"> Firmar documento</h2><br>
                <v-row>
                  <v-col cols="12" md="8">
                    <v-row class="">
                      <v-col cols="12">
                        <p v-if="currentUser.segundo_apellido" class="font-weight-black ml-15" align="left">Se dispone a firmar documento
                          {{currentUser.nombre+' '+currentUser.primer_apellido+' '+currentUser.segundo_apellido}}
                        </p>
                        <p v-else class="font-weight-black ml-15" align="left">Se dispone a firmar documento
                          {{currentUser.nombre+' '+currentUser.primer_apellido+' '}}
                        </p>
                      </v-col>
                    </v-row>

                    <v-row class="mt-n6 ml-3">
                      <v-col cols="12" md="10" align="">
                        <v-file-input
                          v-model="file_firel"
                          color="blue darken-2"
                          label="Seleccionar la firel"
                          prepend-icon="mdi-certificate"
                          outlined
                          dense
                          multiple
                          show-size
                          accept=".pfx"
                          @change="SeleccionarPfxNes($event)"
                          truncate-length="50"
                        ></v-file-input>
                      </v-col>
                    </v-row>

                    <v-row class="mt-n6 ml-3">
                      <v-col cols="12" md="10">
                        <v-text-field
                          outlined dense
                          v-model="password"
                          label="Contraseña"
                          type="text"
                          prepend-icon="mdi-lock-outline"
                          :type="showpass ? 'text' : 'password'"
                          :append-icon="showpass ? 'mdi-eye' : 'mdi-eye-off'"
                          @click:append="showpass = !showpass"
                          truncate-length="50"
                        >
                        </v-text-field>
                      </v-col>
                      <v-col cols="2">
                        <v-row class="">
                          <v-col cols="2">
                            <v-btn
                              class="white--text"
                              :loading="loading"
                              :disabled="!activarBoton"
                              @click="AgregarFirmanteNes()"
                              color="#607D8B">FIRMAR
                            </v-btn>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-container>
            </v-card>

            <v-card
              class="mx-auto"
              v-else-if="currentUser.id == item.magistrado_id && item.firmado == 1"
            >
              <v-alert
                border="top"
                colored-border
                type="success"
                elevation="2"
              >
                <v-row class="">
                  <v-col cols="12" md="10">
                    <b>Usted ya ha firmado el documento</b>
                  </v-col>
                </v-row>

                <v-spacer></v-spacer>

              </v-alert>
            </v-card>
          </template>
          <!-- <v-card> -->
          <v-row v-if="currentDocumento.url_evidencia">
            <v-col cols="12" md="12" class="mx-1">
              <v-alert
                border="top"
                colored-border
                type="success"
                icon="mdi-draw-pen"
                elevation="2"
              >
                <b>La evidencia criptográfica ya ha sido generada </b>
              </v-alert>
            </v-col>
          </v-row>
          <!-- </v-card> -->
          <v-row v-if="roleUser == 'secacu' && !currentDocumento.url_evidencia">
          <!-- <v-row class="mt-1" justify="center" v-if="!currentDocumento.url_evidencia"> -->
            <v-col cols="12" md="12" align="center">
              <v-btn
                dark
                small
                class="ml-1 mt-3"
                color="#607D8B"
                :loading="loadingFirma"
                :disabled="archivo.encode != '' || total_firmas < firmasList.length"
                @click="firmar()"
              >
                <v-icon left>
                  mdi-send
                </v-icon>
                Generar evidencia
              </v-btn>
            </v-col>
          </v-row>
          <v-row justify="center">
            <v-col v-if="archivo.file_name" cols="12" md="12" align="center">
              <!-- <ul>
                <li> -->
                  <h3><b>Documento Firmado:</b>
                    {{ archivo.file_name }}
                    <v-icon
                      color="green"
                    >mdi-check</v-icon>&nbsp;
                    <v-img @click="saveTextAsFile()"  :src="path_logo_pdf" style="max-height: 33px; max-width: 33px; cursor: pointer"/>
                    <v-btn
                      dark
                      x-small
                      @click="saveTextAsFile()"
                      color="#607D8B">Ver Evidencia
                    </v-btn>&nbsp;
                  </h3>
                <!-- </li>
              </ul> -->
            </v-col>
          </v-row>
          <v-divider></v-divider>
          <v-card-actions class="">
            <v-spacer></v-spacer>
            <v-btn
              class="mb-3 mt-5"
              color="grey darken-1"
              text
              :loading="loading"
              @click.native="close">Cerrar
            </v-btn>
            <v-btn
              v-if="roleUser == 'secacu'"
              class="mb-3 mt-5"
              color="#1D2E4B"
              text
              :loading="loading"
              :disabled="archivo.encode == ''"
              @click="saveEvidencia()"
            >
              Guardar Evidencia
            </v-btn>
          </v-card-actions>
        </v-form>

      </v-card-text>
    </v-card>
    <v-dialog
      v-model="progress"
      hide-overlay
      persistent
      width="300"
    >
      <v-card
        color="#0A4A79"
        dark
      >
        <v-card-text>
          Cargando Archivo
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
  import { _filesToSign, _Keys, AddSignerNes, SignMultifirmaNes, PKCS7creado, infoCer } from '@/services/multifirma';
  import { CertificateRequest } from '@/services/clasesFirma';
  const Swal = require('sweetalert2');
  import { mapGetters } from "vuex";

  export default {
    props: {
      documento_id: {
        required: true
      },
    },
    data() {
      return {
        currentDocumento:'',
        dialog:false,
        loading: false,
        loadingFirma: false,
        valid: true,
        showpass: false,
        activarBoton: false,
        progress: false,
        Keys: [],
        bufferFile: '',
        files:[],
        file:[],
        file_firel: [],
        path_logo_pdf:require('@/assets/img/file-pdf.svg'),
        apelacion_id:'',
        total_firmas: '',
        url_multifirma:'',
        archivo:{
          encode:'',
          type:'application/pdf',
          size:'',
          file_name:''
        },
        archivoDefault:{
          encode:'',
          type:'application/pdf',
          size:'',
          file_name:''
        },
        sign:true,
        // user:'',
        password:'',
        MisFirmasList:[],  //para almacenas las firmar retornadas del backen
        LaFirmaActual:[],  //se usa para guardar el objeto de firma como se guardara en la DB
        firmasList:[]
      }

    },
    computed: {
      formTitle () {
        return 'Documento'
      },
      // ...mapGetters(["currentUser", "firmasList", "roleUser"]),
      ...mapGetters(["currentUser", "roleUser"]),
    },
    watch: {
      documento_id: function (val) {
        this.showDocumento()
        this.getFirmas()
      }
    },
    created() {
      // this.apelacion_id =  JSON.parse(localStorage.getItem("currentApelacion"))
      // this.documento_id =  JSON.parse(localStorage.getItem("currentDocument"))
      this.showDocumento()
      this.getFirmas()
      // this.getBufferFile()
    },
    methods:{
      ///START METHODS NESTOR
      //comprobar el pfx que se valido
      SeleccionarPfxNes(filePFX) {
        if (filePFX.length) {
          this.handleUploadUser(filePFX).then((isValidFile) => {
            if (isValidFile) {
              // console.log('Archivo PFX cargado');
              // console.log(_Keys);
              this.activarBoton = true
            }
          });
        }
      },

      handleUploadUser(pfxFile) {
        this.LaFirmaActual = []
        var file = pfxFile[0];
        console.log("mi file", file)
        try {

          var fileReader = new FileReader();
          fileReader.readAsArrayBuffer(file);
          //leer el archivo pfx y convierte a array fuuefr
          /*if (_Keys.length>0) {
            _Keys.splice(_Keys.indexOf(_Keys.length -1), 1);
          }*/
          return new Promise((resolve,reject)=>{
            fileReader.onload = (e) => {
              var pfx = e.target.result;
              // AddKey(pfx, file.name);

              let key = {
                Pfx:'',
                FileName:'',
                PrivatePEM:'',
                CertPEM:'',
                Status:'',
                Error:''
              };
              key.Pfx = pfx;
              key.FileName = file.name;
              //aqui  en this.LaFirmaActual ya tenemos la firma del firmante actual que se guardara en la BD
              this.LaFirmaActual.push( key );
              console.log("la firma actual",this.LaFirmaActual)

              if (this.LaFirmaActual.length > 0) {
                resolve(true);
              }
              /*if (_Keys.length>0) {
                resolve(true);
              }*/
              resolve(false);
            };

          });

        } catch (e) {
          console.error(e);
        }
      },

      AgregarFirmanteNes() {

        //Validar que ingrese la contraseña
        if (!this.password){
          Swal.fire({
            icon: 'warning',
            title: 'Ingrese su contraseña',
            showConfirmButton: false,
            timer: 1500
          })
          return
        }

        AddSignerNes(this.LaFirmaActual,this.password).then((isValid) => {
          // console.log("is valid", isValid)
          this.loading = true;

          //VALIDAR QUE NO SE REPITA LA CURP

          // al enconrtarse un error como que la comtraseña no coincide
          if(isValid.valid == false){

            Swal.fire({
              icon: 'warning',
              title: 'Contraseña de Firel No Válida',
              confirmButtonText: "Aceptar",
            })
            this.loading = false;
            // setTimeout(()=>{
            //   location.reload();
            // }, 2000);

            return false
          }

          if (isValid.valid == true) { //si se cumplio la promesa

            console.log("isV", isValid)
            var curp_repetida = false;

            /*VALIDAR LA VIGENCIA DE LA FIREL*/
            console.log("la videncia info cert", infoCer)
            if (!infoCer.VigenciaValida) {
              // this.password = "";
              //this.file_firel = [];
              this.activarBoton = false
              Swal.fire({
                icon: 'warning',
                title: 'La vigencia de su Firel no es válida',
                confirmButtonText: "Aceptar",
              })
              this.loading = false;

              // setTimeout(()=>{
              //   location.reload();
              // }, 2000);
              return false
            }

            //firmasList trae todas los records de la DB de firmantes
            this.firmasList.forEach(firma => {
              if (firma.curp_firma == infoCer.CURPFirel) {
                console.log("una firma foreach", firma)
                curp_repetida = true
              }
            });

            if(curp_repetida){
              Swal.fire({
                icon: 'warning',
                title: 'La curp correspondiente a la firma ya se encuentra registrada',
                confirmButtonText: "Aceptar",
              })
              this.loading = false;

              // setTimeout(()=>{
              //   location.reload();
              // }, 2000);

              return false
            }

            var url = "/multifirma/" + this.documento_id + "/magistrado/" + this.currentUser.id
            const firma = {
              firma: isValid.firmante,
              curp_firma: infoCer.CURPFirel,
              // serial_number: infoCer.SerialNumber
            }

            this.$store.dispatch("SAVE_FIRMA_MAGISTRADO", {url: url, data: firma})
              .then(response => {
                // console.log(response.data);
                Swal.fire({
                  icon: 'success',
                  title: 'Firmado con Éxito',
                  confirmButtonText: "Aceptar",
                  timer: 1500,
                })
                this.loading = false;
                // location.reload();
                this.getFirmas()
              })
              .catch(error => {
                console.log(error);
              });
          }
        });
      },

      ///END METHODS NESTOR

      firmar() {
        // var extFileUpload= files[i].name.split('.')[1];
        var fileName = this.currentDocumento.nombre_original
        // var realName = fileName.split('.pdf')[0]
        var realName = this.currentDocumento.nombre_original
        //console.log(fileName);
        //return
        //SignMultifirma(this.Keys, this.bufferFile, fileName).then((isCreatePKCS7)=>{
        SignMultifirmaNes(this.MisFirmasList, this.bufferFile, fileName).then((isCreatePKCS7)=>{
          if(isCreatePKCS7){
            var fecha = new Date();
            this.pkcs7=PKCS7creado;
            // this.FileName = "pkcs7_" + fecha.valueOf() + "." + this.extArchivoCargado;
            this.FileName = "pkcs7_" + fecha.valueOf() + ".pdf" ;
            // console.log(PKCS7creado);
            this.creaEvidencia(this.pkcs7);
          }
        });
      },

      creaEvidencia(pkcs7)
      {
        Swal.fire({
          title: 'Estableciendo comunicación',
          html: 'Generando Evidencia Criptográfica ...',
          // timer: 5000,
          allowOutsideClick: false,
          showConfirmButton: false,
          onBeforeOpen: () => {
            Swal.showLoading()
          },
        })
        this.creaevidencia=true;
        this.loadingFirma = true;
        if(pkcs7){
          CertificateRequest.CertificateType = 3;
          CertificateRequest.Pkcs7Original = this.pkcs7;
          CertificateRequest.FileName = this.FileName;
          CertificateRequest.UserName = "Eliminar";
          // console.log(CertificateRequest);
          this.$store.dispatch("FIREL_FIRMA", { url: "promocion/firmar", data: CertificateRequest }).then(response => {
            Swal.close();
            // console.log(response.data);
            this.loadingFirma = false;
            Swal.fire({
              icon: 'success',
              title: 'Documento Firmado con Éxito',
              confirmButtonText: "Aceptar",
              timer: 1500,
            })
            this.archivo.encode = response.data.data.resultados.PdfBase64;
            this.archivo.size = this.currentDocumento.size_original;
            var fecha = new Date();
            this.archivo.file_name = "evidencia_" + fecha.valueOf();
            // console.log(this.archivo);
            this.filePFX = [];
            this.file = [];
            this.password = '';
            this.activarBoton = false;
          })
            .catch(err => {
              console.log(err);
              this.loadingFirma = false;
            });
        } else {
          this.creaevidencia=false;
        }
      },

      saveEvidencia() {
        this.loading = true
        this.url_multifirma = "/multifirma/"+this.documento_id+"/guardar-multifirma"
        const data = {
          file: this.archivo,
          // nombre: this.nombre_contestacion
        }
        // console.log(data);
        this.$store.dispatch("SAVE_CONTESTACION",  { url: this.url_multifirma, data: data })
          .then(response => {
            Swal.fire({
              icon: 'success',
              title: 'Evidencia guardada con éxito',
              confirmButtonText: "Aceptar"
            })
            var signed = response.data.data.documento.signed
            this.file_firel = []
            this.file_firel.value = null
            this.password = ''
            this.archivo = Object.assign({}, this.archivoDefault)
            this.activarBoton = false
            this.LaFirmaActual = []
            this.loading = false
            this.$emit('close', signed)
            // this.close();
            // if (this.roleUser == 'secacu') {
            //   this.$router.push('/secacuerdos')
            // } else {
            //   this.$router.push('/tocas')
            // }

          })
          .catch(error => {
            this.loading = false
            console.log(error);
            Swal.fire({
              icon: 'error',
              title: 'Error',
              text: error.response.data.message,
              confirmButtonText: "Aceptar"
            });
            // this.close();
          });
      },

      getBufferFile(){
        this.loadingFirma = true
        var url = "/documento/"+ this.documento_id +"/previo-multifirma"
        this.$store.dispatch("GET_FILE", { url: url })
          .then((response) => {
            this.bufferFile = response.data
            if (this.bufferFile!='') {
              this.loadingFirma = false;
            }
            //console.log("desde getBufferFile",this.bufferFile);
          })
          .catch(err => {
            console.log(err);
          });
      },

      showDocumento(){
        this.$store.dispatch("SHOW_PROMOCION", {
          url:"/documento/"+ this.documento_id,
        } )
          .then((response) => {
            // console.log(response.data.data);
            this.currentDocumento = response.data.data.documento
            if (!this.currentDocumento.url_evidencia && this.roleUser == 'secacu') {
              this.getBufferFile()
            }
            // console.log(this.currentDocumento);
            // this.$router.push('/escritos/show' )
          })
          .catch(err => {
            console.log(err);
          });
      },
      getFile(tipo){
        var url = "/documento/"+ this.documento_id +"/previo-multifirma"
        if (tipo == 'evidencia') {
          url = "/documento/"+ this.documento_id +"/multifirma-evidencia"
        }
        this.progress = true
        this.$store.dispatch("GET_FILE", { url: url }).then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('target' ,'_blank');
          document.body.appendChild(link);
          link.click();
          this.progress = false
        })
          .catch(err => {
            console.log(err);
            this.progress = false
          });
      },

      getFirmas() {
        var url = "/multifirma/"+ this.documento_id +"/firmas"
        this.$store.dispatch("GET_FIRMAS",  { url: url })
          .then(response => {
            // console.log("get firmas",response.data);
            this.Keys = []
            this.MisFirmasList = []
            var firmasResponse = response.data.data.firmas
            this.firmasList = firmasResponse
            var countfirmas = 0
            // console.log("firmas response", firmasResponse)
            // console.log("contador de firmas 1",countfirmas)
            firmasResponse.forEach(firma => {
              if (firma.firmado == 1) {
                countfirmas ++
                // console.log("contador foreach",countfirmas)

                //this.Keys.push(JSON.parse(firma.firma)) ocmentador por nestor
                this.MisFirmasList.push( JSON.parse(firma.firma) )
              }
            });
            // console.log('MisFirmasList:', this.MisFirmasList);
            // console.log("contador de firmas final",countfirmas)

            // console.log('Keys',this.Keys);
            this.total_firmas = countfirmas
            // console.log("count total de firmas",this.total_firmas)

            // console.log(countfirmas);
            // console.log(firmas.length);
            if (firmasResponse.length == countfirmas) {
              this.firmado = true
            } else {
              this.firmado = false
            }
            // console.log(this.Keys);
          })
          .catch(error => {
            console.log(error);
          });
      },

      saveTextAsFile() {
        var fileB64 = this.archivo.encode
        var fecha = new Date();
        let blob = this.b64toBlob(fileB64, 'application/pdf', 512);
        let fileNameToSaveAs = "evidencia_" + fecha.valueOf() + ".pdf";
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('target' ,'_blank');
        // link.setAttribute('download', fileNameToSaveAs);
        document.body.appendChild(link);
        link.click();
      },

      b64toBlob(b64Data, contentType, sliceSize) {
        contentType = contentType || '';
        sliceSize = sliceSize || 512;

        var byteCharacters = atob(b64Data);
        var byteArrays = [];

        for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
          var slice = byteCharacters.slice(offset, offset + sliceSize);

          var byteNumbers = new Array(slice.length);
          for (var i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
          }

          var byteArray = new Uint8Array(byteNumbers);

          byteArrays.push(byteArray);
        }

        var blob = new Blob(byteArrays, { type: contentType });
        return blob;
      },

      close () {
        if (this.roleUser == 'secacu' && this.archivo.file_name) {
          Swal.fire({
            icon: 'warning',
            title: 'Para continuar, Favor de dar click en el Botón Guardar Evidencia',
            confirmButtonText: "Aceptar"
          })
          return false;
        }
        this.file_firel = []
        this.file_firel.value = null
        this.password = ''
        this.archivo = Object.assign({}, this.archivoDefault)
        this.activarBoton = false
        this.LaFirmaActual = []
        this.$emit('close')
        // this.$refs.form.resetValidation()
        // this.dialogFirmantes = false
        // this.documento_id = ''
        // this.data = Object.assign({}, this.defaultData)
      },

    }
  }
</script>
